if (!window.cstmBuyNowInitialized) {
  window.cstmBuyNowInitialized = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.hasAttribute('disabled')) return;

    const form = document.getElementById(button.dataset.formId);
    if (!form) return;

    event.preventDefault();
    button.setAttribute('disabled', 'disabled');
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const formData = new FormData(form);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          button.removeAttribute('disabled');
          button.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          return;
        }
        window.location.href = window.routes.checkout_url;
      })
      .catch(() => {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });
}
